export default __webpack_public_path__ + "images/commercial-electronics-install-service.jpg";